import type { EndUboRoleResult } from '@commenda/api';
import { pluralize } from '@commenda/utils';

export const getUboRemovalMessage = (
  name: string,
  {
    remainsBeneficialOwnerViaPaths,
    cascadedRemovals,
  }: Pick<
    EndUboRoleResult,
    'remainsBeneficialOwnerViaPaths' | 'cascadedRemovals'
  >
): string => {
  const base = remainsBeneficialOwnerViaPaths
    ? `${name} no longer holds a UBO role here, but stays a beneficial owner through inherited ownership.`
    : `${name} is no longer a beneficial owner of this entity.`;
  return cascadedRemovals.length > 0
    ? `${base} ${pluralize(cascadedRemovals.length, 'downstream record')} also removed.`
    : base;
};
